import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConstants } from 'src/app/app.constants';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ErrorHandlerService } from "src/app/core/services/error-handler.service";

@Injectable({
  providedIn: 'root'
})
export class NewApiCostingService {

  constructor(private http: HttpClient, private router: Router, private errorHandlerService: ErrorHandlerService) { }
  investment_cost = '/assets/mockdata/Investment_Costing.json';


  getInvestmentCostDetails() {
    return this.http.get(this.investment_cost);
  }

  displayAPICost(data) {
    return this.http.post(`${AppConstants.API_ENDPOINT}${AppConstants.API.NEW_COSTING.API_COST}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  editAPICost(data) {
    return this.http.post(`${AppConstants.API_ENDPOINT}${AppConstants.API.POSTAPICOST.EDIT_APICOST}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getRegulatoryCost(data): Observable<any[]> {
    return this.http.post<any[]>(`${AppConstants.API_ENDPOINT}${AppConstants.API.NEW_COSTING.REGULATORY_COST}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  displayBEStudy(data) {
    return this.http.post(`${AppConstants.API_ENDPOINT}${AppConstants.API.NEW_COSTING.BE_STUDY_COST}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  rldStudyCost(data) {
    // return this.http.get(this.rld_cost);
    return this.http.post(`${AppConstants.API_ENDPOINT}${AppConstants.API.NEW_COSTING.RLD_COST}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getAnalyticalCost(data) {
    return this.http.post(`${AppConstants.API_ENDPOINT}${AppConstants.API.NEW_COSTING.COMPLEXITY_COST}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getIpCost(data) {
    return this.http.post(`${AppConstants.API_ENDPOINT}${AppConstants.API.NEW_COSTING.IP_COST}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getPackageCost(data) {
    return this.http.post(`${AppConstants.API_ENDPOINT}${AppConstants.API.NEW_COSTING.PACKAGE_COST}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getTimeline(data) {
    return this.http.post(`${AppConstants.API_ENDPOINT}${AppConstants.API.Timelines.POST}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getCumulativeInvestment(data) {
    return this.http.post(`${AppConstants.API_ENDPOINT}${AppConstants.API.CUMULATIVE_INVESTMENT.POST}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }
}
